import { useState } from 'react'
import { Link } from 'react-router-dom'
import { BookOpen, Home, Menu, Wrench, X } from 'lucide-react'

const navItems = [
  { to: '/', label: '首页', icon: Home },
  { to: '/guides/', label: '资料库', icon: BookOpen },
  { to: '/tools', label: '在线工具', icon: Wrench }
]

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  return (
    <nav className="sticky top-0 z-50 border-b border-slate-200 bg-[#f7f3ea]/90 backdrop-blur">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2" onClick={() => setIsMobileMenuOpen(false)}>
            <span className="flex h-9 w-9 items-center justify-center rounded-2xl bg-slate-950 text-white">
              <Wrench className="h-5 w-5" />
            </span>
            <span className="hidden text-xl font-black tracking-tight text-slate-950 sm:block">Parentool</span>
            <span className="text-lg font-black text-slate-950 sm:hidden">Parentool</span>
          </Link>

          <div className="hidden items-center gap-1 md:flex">
            {navItems.map(item => {
              const Icon = item.icon
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className="flex items-center gap-1 rounded-md px-3 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-white hover:text-slate-950"
                >
                  <Icon className="h-4 w-4" />
                  <span>{item.label}</span>
                </Link>
              )
            })}
          </div>

          <div className="md:hidden">
            <button 
              className="text-slate-700 hover:text-slate-950 focus:outline-none p-2"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-slate-200">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navItems.map(item => {
                const Icon = item.icon
                return (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="flex items-center space-x-2 rounded-md px-3 py-2 text-base font-medium text-slate-700 transition-colors hover:bg-white hover:text-slate-950"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <Icon className="h-5 w-5" />
                    <span>{item.label}</span>
                  </Link>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navigation
